export default __webpack_public_path__ + "static/media/scan-me.faf9b558.svg";